<template>
  <v-simple-table style="width: 100%;">
    <thead>
      <tr>
        <th class="text-left">
          วันที่
        </th>
        <th class="text-left">
          3 ตัวบน
        </th>
        <th class="text-left">
          2 ตัวบน
        </th>
        <th class="text-left">
          2 ตัวล่าง
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="game_round in game.rounds"
        :key="game_round.uuid"
      >
        <td>{{ safeDate(game_round.round_rooms[0] && game_round.round_rooms[0].win_number && game_round.round_rooms[0].win_number.created_at) }}</td>
        <td>{{ game_round.round_rooms[0] && game_round.round_rooms[0].win_number && game_round.round_rooms[0].win_number.three_up || 'xxx' }}</td>
        <td>{{ game_round.round_rooms[0] && game_round.round_rooms[0].win_number && game_round.round_rooms[0].win_number.three_up.slice(-2) || 'xx' }}</td>
        <td>{{ game_round.round_rooms[0] && game_round.round_rooms[0].win_number && game_round.round_rooms[0].win_number.two_down || 'xx' }}</td>
      </tr>
    </tbody>
  </v-simple-table>
</template>
<script>

export default {
  props : {
    game : {
      type: Object,
      default: () => ({})
    },
  },
  methods: {
    safeDate (date) {
      return date ? this.$options.filters.dateFormat(date) : '-';
    }
  }
}
</script> 